import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/Index.vue'
import Layout from '@/layout'

//获取单个目录下的路由，路由表写在具体目录下
import jrcRouter from "./../views/jinRongCheng/route.js"
import v2RouteList from "./../views/v2/v2Router"

Vue.use(VueRouter)
const routes = [
  {
    path: '/index',
    name: 'index',
    component: index
  },
  {
    path: '/login',
    component: () => import('../views/login/index'),
    hidden: true
  },
  {
    path: '/log',
    component: Layout,
    children: [
      {
        path: '/log',
        name: 'log',
        component: () => import('@/views/dashboard/index'),
        meta: { title: '日志记录', icon: 'dashboard' }
      },
      {
        path: '/nini',
        name: 'nini',
        component: () => import('@/views/admin'),
        meta: { title: '记录', icon: 'dashboard' }
      }
    ]
  },
  {
    path: '/Qrcode',
    name: 'Qrcode',
    component: () => import('../views/jinRongCheng/Qrcode/index.vue')
  },
  ...jrcRouter,
  ...v2RouteList
]




const router = new VueRouter({
  routes,
  history: "hash"
})
// router.beforeEach((to, from, next) => {
//   if (to.path == '/index') {
//     next();
//   } else {
//     let token = localStorage.getItem('user');
//     if (token === null || token === '') {
//       // location.reload()
//     } else {
//       next()
//     }
//   }
// })

export default router
